import { render } from "./AdminBookingDetailsView.vue?vue&type=template&id=68241286&scoped=true&ts=true&lang=pug"
import script from "./AdminBookingDetailsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminBookingDetailsView.vue?vue&type=script&setup=true&lang=ts"

import "./AdminBookingDetailsView.vue?vue&type=style&index=0&id=68241286&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68241286"]])

export default __exports__